// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"66929570","126":"ec8b81a0","171":"01db9901","378":"a8c9ab8f"}[chunkId] + ".chunk.js";
};